/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetSocialConnectionsConnectionsForStationQueryResponse, WebAppGetSocialConnectionsConnectionsForStationPathParams, WebAppGetSocialConnectionsConnectionsForStationQueryParams } from "../models/WebAppGetSocialConnectionsConnectionsForStation";

export function getWebAppGetSocialConnectionsConnectionsForStationUrl(station: WebAppGetSocialConnectionsConnectionsForStationPathParams["station"]) {
  const res = { method: 'GET', url: `/web-app/social-connections/${station}` as const }
  return res
}

/**
 * @summary Get connection states for a station (optional `platform` query filters to one platform)
 * {@link /web-app/social-connections/:station}
 */
export async function webAppGetSocialConnectionsConnectionsForStation(station: WebAppGetSocialConnectionsConnectionsForStationPathParams["station"], params?: WebAppGetSocialConnectionsConnectionsForStationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getWebAppGetSocialConnectionsConnectionsForStationUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}